import React from 'react'
import { FlexboxGrid, Stack, Toggle } from 'rsuite'

const CollSubM = () => {
  return (
    <>
                  <b>Features</b>
                  <FlexboxGrid>
                    <FlexboxGrid.Item colspan={6}>
                      <div
                        style={{
                          padding: '8px',
                          width: '200px',
                          background: 'aliceblue',
                          borderRadius: '6px',
                          margin: '4px'
                        }}
                      >
                        <Stack justifyContent="space-between">
                          <Toggle size="sm" />
                          <p>PPT</p>
                        </Stack>
                      </div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={6}>
                      <div
                        style={{
                          padding: '8px',
                          width: '200px',
                          background: 'aliceblue',
                          borderRadius: '6px',
                          margin: '4px'
                        }}
                      >
                        <Stack justifyContent="space-between">
                          <Toggle size="sm" />
                          <p>PDF</p>
                        </Stack>
                      </div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={6}>
                      <div
                        style={{
                          padding: '8px',
                          width: '200px',
                          background: 'aliceblue',
                          borderRadius: '6px',
                          margin: '4px'
                        }}
                      >
                        <Stack justifyContent="space-between">
                          <Toggle size="sm" />
                          <p>Excel</p>
                        </Stack>
                      </div>
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </>
  )
}

export default CollSubM
